import React from 'react'
import { ReactComponent } from './document-scanner.svg'
import { MergeReactElementProps } from '../types'

interface DocumentScannerProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', DocumentScannerProps>

export const DocumentScanner = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill='none' ref={ref} {...props} />
  }
)
